import * as yup from "yup";

const initialValues = {
    projectName: "",
    isPublic: false,
};

const validationSchema = yup.object({
    projectName: yup.string().required("Project name is required"),
    description: yup.object(),
})

export { validationSchema as default, initialValues };